import ArrowLeftIcon from '../svg/ArrowLeftIcon';

export default function ComeBack({ text, onClick }) {
  return (
    <div className="flex items-center space-x-2">
      <button onClick={onClick} className="cursor-pointer">
        <ArrowLeftIcon size="w-6 h-6" color="#092F7B" />
      </button>
      <p className="text-lg text-[#181D27] font-semibold leading-[20px]">
        {text}
      </p>
    </div>
  );
}
